import { DATE_RELATIONS } from '@frontend/api';

export const SET_UNIT_DATE_RELATIONS = [
  DATE_RELATIONS.IN_THIS_HOUR,
  DATE_RELATIONS.TODAY,
  DATE_RELATIONS.IN_THIS_WEEK,
  DATE_RELATIONS.IN_THIS_MONTH,
  DATE_RELATIONS.IN_THIS_YEAR,
  DATE_RELATIONS.NEVER,
] as const;
